module.exports = __webpack_public_path__ + "img/DRmed-03.4908267f.png";